export const useIsIPhone = () => {
  return /iPhone/i.test(navigator.userAgent)
}

export const useIsIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export const useIsAppleDevice = () => {
  return /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent)
}
